const fonts = {
  notoSans: 'Noto Sans',
  nanumGothic: 'Nanum Gothic',
  nunito: 'Nunito',
  didactGothic: 'Didact Gothic',
  trebuchet: "Trebuchet MS",
};

export default fonts;
